import { serverApi } from "./serverApi";
import {
  Section,
  TestrailRun,
  TestrailTestCaseRunRequest
} from "../types/testrailTypes";

export const testrailService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllTestRuns: build.query<Array<TestrailRun>, string>({
      query: () => ({
        url: "/testrail/all-test-runs"
      })
    }),
    getAllSections: build.query<Array<Section>, string>({
      query: () => ({
        url: "/testrail/all-sections"
      })
    }),
    runTestrailTestCase: build.mutation<void, TestrailTestCaseRunRequest>({
      query: (body) => ({
        url: "/testrail/test-case/run",
        method: "POST",
        body
      })
    }),
    runTestrailTestCaseGroup: build.mutation<void, Array<TestrailTestCaseRunRequest>>({
      query: (body) => ({
        url: "/testrail/test-case-group/run",
        method: "POST",
        body
      })
    }),
  })
});

export const {
  useGetAllTestRunsQuery,
  useGetAllSectionsQuery,
  useRunTestrailTestCaseMutation,
  useRunTestrailTestCaseGroupMutation
} = testrailService;